import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import {
  sanitizeLocQueryParam,
  sanitizeLocationPathParam,
} from '@/helpers/String/sanitizeQueryParams';

export const useDirectoryRouteLocations = (): ComputedRef<string[]> => {
  const route = useRoute();

  return computed(() => {
    const locations: string[] = [];

    const pathLocation = sanitizeLocationPathParam(route.params.location);
    if (pathLocation) {
      locations.push(pathLocation);
    }

    locations.push(...sanitizeLocQueryParam(route.query.loc));

    return locations;
  });
};
